import SlideshowInterface from 'types/Slideshow';
import { screen } from 'components/styles/variables';
import RelatedArticles from 'components/Article/RelatedArticles';
import * as _ from 'lodash-es';
import { CtaButton } from 'components/Shared/CtaButton';
import TitleComponent from 'components/Slideshow/TitleComponent';
import { SourcePages } from 'lib/EventSchema';
import MobileSlideshow from './MobileSlideshow';
import DesktopSlideshow from './DesktopSlideshow';

interface SlideshowProps {
  slideshow: SlideshowInterface;
}

const NUMBER_OF_RELATED_ARTICLES_TO_SHOW = 3;

function Slideshow({ slideshow }: SlideshowProps): JSX.Element {
  const { related, category, slug, ctaText, ctaURL, title, author, publicationDate } = slideshow;
  const categoryName = _.get(category, 'name') || '';
  const parentCategoryName = _.get(category, 'parentCategory.name') as string;
  const eventsData = {
    categoryName: categoryName as SourcePages,
    pageName: `/gallery/${slug}`,
  };

  return (
    <div className="outer-slideshow-container">
      <TitleComponent title={title} author={author} date={new Date(publicationDate)} />
      <div className="mobile-slideshow-container">
        <MobileSlideshow slideshow={slideshow} />
      </div>
      <div className="desktop-slideshow-container">
        <DesktopSlideshow slideshow={slideshow} eventsData={eventsData} />
      </div>
      {related && related.length > 0 && (
        <div className="related-articles-container" data-testid="related-articles">
          <RelatedArticles
            related={related.slice(0, NUMBER_OF_RELATED_ARTICLES_TO_SHOW)}
            eventsData={eventsData}
            parentCategoryName={parentCategoryName}
            isSlideshow={true}
          />
        </div>
      )}
      <div className="cta">
        {ctaText && ctaURL && category && (
          <CtaButton
            ctaText={ctaText}
            ctaURL={ctaURL}
            category={category}
            pageName={eventsData.pageName}
          />
        )}
      </div>
      <style jsx>{`
        .outer-slideshow-container {
          display: flex;
          align-items: center;
          flex-direction: column;
        }

        .desktop-slideshow-container {
          display: none;
        }

        .related-articles-container {
          padding: 0px 20px;
        }

        .cta {
          display: flex;
          justify-content: center;
          padding: 15px 0px 35px 0px;
        }

        @media (min-width: ${screen.smMin}) {
          .mobile-slideshow-container {
            display: none;
          }

          .desktop-slideshow-container {
            display: flex;
            justify-content: center;
          }

          .related-articles-container {
            width: 728px;
            padding: 40px 20px 0px 20px;
          }

          .cta {
            padding: 30px 0px 40px 0px;
          }
        }

        @media (min-width: ${screen.mdMin}) {
          .related-articles-container {
            margin-left: 105px;
          }

          .cta {
            display: flex;
            justify-content: center;
            margin-left: 105px;
            margin-bottom: 20px;
            width: 728px;
          }
        }

        @media (min-width: ${screen.lgMin}) {
          .related-articles-container {
            margin-left: 40px;
          }

          .cta {
            margin-left: 40px;
          }
        }

        .cta {
          display: flex;
          justify-content: center;
          margin-bottom: 20px;
          max-width: 727px;
        }
      `}</style>
    </div>
  );
}

export default Slideshow;
